import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbsolutePipe } from './absolute.pipe';
import { AutolinkerPipe } from './autolinker.pipe';
import { ConsolePipe } from './console.pipe';
import { DurationFormatPipe } from './duration.pipe';
import { FilterPipe } from './filter.pipe';
import { LeadtimePipe } from './leadtime.pipe';
import { PercentageChangePipe } from './percentage-change.pipe';
import { PhonePipe } from './phone.pipe';
import { ReverseArrayPipe } from './reverseArray.pipe';
import { SafeHTMLPipe } from './safe-html.pipe';
import { YssCurrencyPipe } from './yss-currency.pipe';

@NgModule({
    declarations: [
        LeadtimePipe,
        AutolinkerPipe,
        SafeHTMLPipe,
        ConsolePipe,
        PhonePipe,
        ReverseArrayPipe,
        DurationFormatPipe,
        YssCurrencyPipe,
        FilterPipe,
        PercentageChangePipe,
        AbsolutePipe,
    ],
    imports: [CommonModule],
    exports: [
        LeadtimePipe,
        AutolinkerPipe,
        SafeHTMLPipe,
        ConsolePipe,
        PhonePipe,
        ReverseArrayPipe,
        DurationFormatPipe,
        YssCurrencyPipe,
        FilterPipe,
        PercentageChangePipe,
        AbsolutePipe,
    ],
})
export class PipesModule {}
